export enum PensionIncomeTypes {
  PENSION = 'pension',
}
